(function () {
  function normalizeUrl(url) {
    if (!url) return '';
    url = String(url).trim().replace(/&amp;/gi, '&');
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    try {
      if (/^https?:\/\//i.test(url)) {
        var u = new URL(url);
        if (u.pathname.indexOf('/cdn/') === 0) {
          return u.pathname + u.search;
        }
      }
    } catch (e) {}
    return url;
  }

  function readDotUrl(dot, dataKey, attrName) {
    if (!dot) return '';
    var v = dot.dataset[dataKey] || '';
    if (!v) v = dot.getAttribute(attrName) || '';
    return normalizeUrl(v);
  }

  function initRoot(root) {
    if (!root || root.dataset.fabricInit === '1') return;
    root.dataset.fabricInit = '1';

    var section = root.closest('.fabric-section') || root;
    var buttons = section.querySelectorAll('.cc-btn');
    var panels = section.querySelectorAll('.cc-panel');
    var photo = section.querySelector('[data-photo]');
    var photoImg = photo ? photo.querySelector('[data-photo-img]') : null;
    var chip = section.querySelector('[data-swatch]');
    var nameEl = section.querySelector('[data-swatch-name]');
    var mq = window.matchMedia('(max-width: 900px)');

    var colorImageMap = {};
    var mapEl = document.getElementById('FabricColorImageMap-' + (section.dataset.sectionId || ''));
    if (!mapEl && section.parentElement) {
      mapEl = section.parentElement.querySelector('[id^="FabricColorImageMap-"]');
    }
    if (mapEl) {
      try {
        colorImageMap = JSON.parse(mapEl.textContent) || {};
      } catch (e) {
        colorImageMap = {};
      }
    }

    function resolveImages(dot) {
      var key = (dot && dot.dataset.clean) || '';
      var fromMap = (key && colorImageMap[key]) || null;
      var pc = readDotUrl(dot, 'imgPc', 'data-img-pc') || normalizeUrl(fromMap && fromMap.pc);
      var mobile = readDotUrl(dot, 'imgMobile', 'data-img-mobile') || normalizeUrl(fromMap && fromMap.mobile);
      return { key: key, pc: pc, mobile: mobile, fromMap: !!fromMap };
    }

    function pickDot(panel) {
      return (
        panel.querySelector('.fab-color.active:not(.out)') ||
        panel.querySelector('.fab-color.active') ||
        panel.querySelector('.fab-color:not(.out)') ||
        panel.querySelector('.fab-color')
      );
    }

    function applyPhoto(dot) {
      if (!dot || !photo) return;
      var imgs = resolveImages(dot);
      var url = mq.matches ? imgs.mobile : imgs.pc;

      if (url) {
        photo.classList.add('has-image');
        photo.style.backgroundImage = '';
        if (photoImg) {
          photoImg.removeAttribute('hidden');
          photoImg.style.display = 'block';
          photoImg.onload = function () {
            if (photoImg.naturalWidth && photoImg.naturalHeight) {
              photoImg.setAttribute('width', String(photoImg.naturalWidth));
              photoImg.setAttribute('height', String(photoImg.naturalHeight));
            }
          };
          if (photoImg.getAttribute('src') !== url) photoImg.src = url;
          photoImg.alt = dot.dataset.name || '';
        } else {
          photo.style.backgroundImage = 'url("' + url.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '")';
        }
      } else {
        photo.classList.remove('has-image');
        photo.style.backgroundImage = '';
        if (photoImg) {
          photoImg.setAttribute('hidden', '');
          photoImg.style.display = 'none';
          photoImg.removeAttribute('src');
          photoImg.removeAttribute('width');
          photoImg.removeAttribute('height');
          photoImg.alt = '';
        }
      }

      if (chip) {
        chip.className = 'chip';
        var sw = (dot.dataset.swatchBg || '').replace(/&amp;/gi, '&');
        if (sw.indexOf('url(') === 0) {
          chip.style.backgroundImage = sw;
          chip.style.backgroundSize = 'cover';
          chip.style.backgroundPosition = 'center';
          chip.style.backgroundColor = '';
        } else if (sw) {
          chip.style.backgroundImage = '';
          chip.style.backgroundColor = sw;
        } else {
          chip.style.backgroundImage = '';
          chip.style.backgroundColor = '';
        }
      }
      if (nameEl) nameEl.textContent = dot.dataset.name || '';
    }

    function sync(fabric) {
      var panel =
        section.querySelector('.cc-panel.active[data-panel="' + fabric + '"]') ||
        section.querySelector('.cc-panel[data-panel="' + fabric + '"]');
      if (!panel) return;
      var dot = pickDot(panel);
      if (!dot) return;
      var colorLabel = panel.querySelector('[data-color-label]');
      if (colorLabel) colorLabel.textContent = dot.dataset.name || '';
      applyPhoto(dot);
    }

    function syncProgress(panel) {
      var imgsWrap = panel.querySelector('[data-fab-imgs]');
      var bar = panel.querySelector('[data-fab-progress]');
      if (!imgsWrap || !bar) return;
      var scrollable = imgsWrap.scrollWidth > imgsWrap.clientWidth + 1;
      imgsWrap.classList.toggle('center', !scrollable);
      bar.classList.toggle('show', scrollable && mq.matches);
      var fill = bar.querySelector('i');
      if (!fill) return;
      if (!scrollable) {
        fill.style.transform = 'scaleX(0)';
        return;
      }
      var ratio = (imgsWrap.scrollLeft + imgsWrap.clientWidth) / imgsWrap.scrollWidth;
      fill.style.transform = 'scaleX(' + Math.max(0.05, Math.min(1, ratio)) + ')';
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        panels.forEach(function (p) {
          p.classList.remove('active');
        });
        var panel = section.querySelector('.cc-panel[data-panel="' + btn.dataset.fabric + '"]');
        if (!panel) return;
        panel.classList.add('active');
        sync(btn.dataset.fabric);
        syncProgress(panel);
      });
    });

    panels.forEach(function (panel) {
      panel.querySelectorAll('.fab-color').forEach(function (dot) {
        dot.addEventListener('click', function () {
          if (dot.classList.contains('out')) return;
          panel.querySelectorAll('.fab-color').forEach(function (x) {
            x.classList.remove('active');
          });
          dot.classList.add('active');
          if (panel.classList.contains('active')) sync(panel.dataset.panel);
        });
      });
      var imgsWrap = panel.querySelector('[data-fab-imgs]');
      if (imgsWrap) {
        imgsWrap.addEventListener(
          'scroll',
          function () {
            syncProgress(panel);
          },
          { passive: true }
        );
      }
    });

    window.addEventListener('resize', function () {
      var active = section.querySelector('.cc-panel.active');
      if (active) {
        sync(active.dataset.panel);
        syncProgress(active);
      }
    });

    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        var active = section.querySelector('.cc-panel.active');
        if (active) sync(active.dataset.panel);
      });
    }

    var firstBtn = section.querySelector('.cc-btn.active') || section.querySelector('.cc-btn');
    if (firstBtn) {
      buttons.forEach(function (b) {
        b.classList.toggle('active', b === firstBtn);
      });
      panels.forEach(function (p) {
        p.classList.toggle('active', p.dataset.panel === firstBtn.dataset.fabric);
      });
      sync(firstBtn.dataset.fabric);
      var activePanel = section.querySelector('.cc-panel.active');
      if (activePanel) syncProgress(activePanel);
    }
  }

  function boot() {
    document.querySelectorAll('[data-fabric-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-fabric-root]').forEach(function (root) {
      delete root.dataset.fabricInit;
      initRoot(root);
    });
  });
})();
